export const limits = {
  // defaultTimeout: 5000,
  maxInputCharacters: 1000000, // main input (10 lakh)
  maxTimeLimit: 30, // main input time limit we have diff in preset time limit
  maxTasksLimit: 500, // Main input chi list maximun tasks you can enter

  // Bucket Limits Starts Here
  maxBucketNameLimit: 50, // Character limit ahe hi bucket name chi
  maxTasksPerPreset: 100, // 100 jastit jast task in bucket
  maxTimeLimitPreset: 150, // 150 min jastit jast per task in Bucket
};

export const messages = {
  double_break_warning_messages: [
    "Another break? Sorry, you just chilled a moment ago! 😊",
    "You just had a break! Time to work. 😊",
    "One break at a time, party animal! 😊",
    "Back-to-back breaks? Nice try - Let's do the next task first 😊",
    "Break again? Remember, last task was a break! 😊",
  ],

  task_time_limit_warning_messages: [
    "Got a big task? Let's break it down to 30 minutes or less.",
    "Stay sharp! Smaller tasks (30 minutes or less) make a big difference.",
    "Let's keep tasks under 30 minutes to stay sharp and efficient!",
    "To stay productive, we've set a 30-minute max per task.",
    "To boost productivity, tasks are limited to 30 minutes max.",
  ],
};

export const colorThemes = {
  classic: {
    backgroundColor: "white",
    secondaryBackgroundColor: "#f0f0f0",
    listItemColor: "#e0e0e0",
    iconColor: "#007bff",
    textNameColor: "#333333",
    timerColor: "#ff5722",
  },
  dark: {
    backgroundColor: "black",
    secondaryBackgroundColor: "#f8f9fa",
    listItemColor: "white",
    iconColor: "#007bff",
    textNameColor: "#495057",
    timerColor: "#17a2b8",
  },
  aqua: {
    backgroundColor: "#79c6df",
    secondaryBackgroundColor: "#e0e0e0",
    listItemColor: "#249db5",
    iconColor: "#4caf50",
    textNameColor: "#212121",
    timerColor: "#9c27b0",
  },
};
